import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import RevenueChart from "./revenue_chart";

const msp = () => ({});
const mdp = () => ({});

export default withRouter(connect(msp, mdp)(RevenueChart));